import { render, staticRenderFns } from "./Ablehnen.vue?vue&type=template&id=583ed260&scoped=true&"
import script from "./Ablehnen.vue?vue&type=script&lang=js&"
export * from "./Ablehnen.vue?vue&type=script&lang=js&"
import style0 from "./Ablehnen.vue?vue&type=style&index=0&id=583ed260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583ed260",
  null
  
)

component.options.__file = "Ablehnen.vue"
export default component.exports